module.exports = __webpack_public_path__ + "img/slim16.583b0be2.jpg";